<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modalId" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
             aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">{{modalTitle}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <alert-component type="success" v-if="this.$store.state.transaction.status === 'success'">
                            <template  v-slot:content>
                                <h5>{{$store.state.transaction.mmessage}}</h5>
                            </template>
                        </alert-component>
                        <alert-component type="danger" v-if="this.$store.state.transaction.status === 'error'">
                            <template  v-slot:content>
                                <h5>{{$store.state.transaction.mmessage}}</h5>
                                <p>{{$store.state.transaction.data}}</p>
                            </template>
                        </alert-component>

                        <h5 v-if="this.$store.state.transaction.status === ''">{{modalBody}}</h5>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Sair</button>
                        <button type="button" class="btn btn-primary" @click="btnAction" v-if="this.$store.state.transaction.status === ''" >{{buttonText}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalComponent",
    props: ['modalId', 'modalTitle', 'modalBody', 'buttonText', 'btnAction', 'buttonDisabled']
}
</script>

<style scoped>

</style>
